import src from "IMAGE";
export default { src, width: 995, height: 221, blurWidth: 0, blurHeight: 0};
